module.exports = __webpack_public_path__ + "static/media/Talent&Successor.ed192799.png";